<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'"
              >Số Serial Sim</label
              >
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="searchPhone"
                  :class="rootClass + '__phone-number-input'"
                  type="number"
                  v-on:keyup.enter="getDkttHistory()"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;margin-right: 4%">
            <b-button
                :class="rootClass + '__search-voice-sms-data-btn'"
                class="redButton"
                style="margin-left: -30%"
                variant="danger"
                @click="getDkttHistory()"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-voice-sms-data-table'">
            <tr style="height: 3rem">
              <template v-for="(h, i) in historyDataTable.fields"
              >
                <th
                    :key="h.key"
                    :class="{
                          '--first-th': i === 0,
                          '--last-th':
                            i === historyDataTable.fields.length - 1,
                        }"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <tr v-for="(i,index) in historyResult" v-if="showErrSearch===false " style="color:black;">
              <td>{{ index + 1 }}</td>
              <td>
                <div class="d-flex justify-content-center">
                  <b-button
                      v-b-tooltip.hover
                      class="mr-1"
                      size="sm"
                      title="Xem video"
                      variant="primary"
                      @click="viewVideo(i.IDNUMBER, i.MSISDN, i.MODIFYDATE)"
                  >
                    <feather-icon icon="VideoIcon" size="14"/>
                  </b-button>
                  <b-button
                      v-b-tooltip.hover
                      size="sm"
                      title="Xem ảnh"
                      variant="success"
                      @click="viewImage(i.IDNUMBER, i.MSISDN, i.MODIFYDATE, index + 1)"
                  >
                    <feather-icon icon="ImageIcon" size="14"/>
                  </b-button>
                </div>
              </td>
              <td>{{ i.ID }}</td>
              <td>{{ i.MSISDN }}</td>
              <td style="min-width: 10rem;">{{ i.NAME }}</td>
              <td>{{ i.BIRTHDAY }}</td>
              <td style="min-width: 15rem">{{ i.ADDRESS }}</td>
              <td>{{ i.GENDER }}</td>
              <td>{{ i.PASSPORT }}</td>
              <td>{{ i.IDNUMBERTYPE }}</td>
              <td>{{ i.IDNUMBER }}</td>
              <td>{{ i.PLACEOFISSUE }}</td>
              <td>{{ i.PLACEDATE }}</td>
              <td>{{ i.COMPANY }}</td>
              <td>{{ i.JOB }}</td>
              <td>{{ i.EMAIL }}</td>
              <td>{{ i.NATIONALITYID }}</td>
              <td style="min-width: 10rem;">{{ i.NOTE }}</td>
              <td style="min-width: 12rem;">{{ i.REGISTERMETHODID }}</td>
              <td>{{ i.MODIFYDATE }}</td>
              <td>{{ i.REGISTERDATE }}</td>
              <td>{{ i.AS_NAME }}</td>
<!--              <td style="min-width: 10rem;">{{i.AGENTID}}</td>-->
<!--              <td>{{ i.KENH }}</td>-->
<!--              <td>{{i.MIEN}}</td>-->
<!--              <td>{{ i.PHAN_LOAI }}</td>-->
            </tr>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>

    <!-- Video Modal -->
    <b-modal
        v-model="showVideoModal"
        :title="'Video - ID: ' + currentVideoId"
        size="xl"
        hide-footer
        @hidden="closeVideoModal"
    >
      <div v-if="videoUrl" class="text-center">
        <video
            ref="videoPlayer"
            :src="videoUrl"
            class="w-100"
            controls
            style="max-height: 70vh"
        ></video>
      </div>
      <div v-else-if="videoLoading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Đang tải video...</p>
      </div>
      <div v-else class="text-center p-4">
        <p class="text-muted">Không thể tải video</p>
      </div>
    </b-modal>

    <!-- Image Modal -->
    <b-modal
        v-model="showImageModal"
        size="xl"
        hide-footer
        @hidden="closeImageModal"
    >
      <template #modal-title>
        <div class="d-flex flex-column">
          <div class="main-title">{{ 'Ảnh giấy tờ - ' + currentImageInfo }}</div>
          <div v-if="c06Info && !c06Loading" class="c06-info mt-2" style="font-size: 14px; font-weight: normal;">
            <div class="d-flex flex-wrap">
              <span class="mr-4 d-flex align-items-center">
                <strong class="mr-1">Họ tên:</strong> {{ c06Info.name || 'N/A' }}
                <feather-icon
                    v-if="c06Info.name_result === 'true' || c06Info.name_result === true"
                    icon="CheckIcon"
                    size="14"
                    class="text-success ml-1"
                />
                <feather-icon
                    v-else-if="c06Info.name_result === 'false' || c06Info.name_result === false"
                    icon="XIcon"
                    size="14"
                    class="text-danger ml-1"
                />
              </span>
              <span class="mr-4 d-flex align-items-center">
                <strong class="mr-1">CCCD:</strong> {{ c06Info.idnumber || 'N/A' }}
                <feather-icon
                    v-if="c06Info.idnumber_result === 'true' || c06Info.idnumber_result === true"
                    icon="CheckIcon"
                    size="14"
                    class="text-success ml-1"
                />
                <feather-icon
                    v-else-if="c06Info.idnumber_result === 'false' || c06Info.idnumber_result === false"
                    icon="XIcon"
                    size="14"
                    class="text-danger ml-1"
                />
              </span>
              <span class="mr-4 d-flex align-items-center">
                <strong class="mr-1">Ngày sinh:</strong> {{ formatDob(c06Info.dob) || 'N/A' }}
                <feather-icon
                    v-if="c06Info.dob_result === 'true' || c06Info.dob_result === true"
                    icon="CheckIcon"
                    size="14"
                    class="text-success ml-1"
                />
                <feather-icon
                    v-else-if="c06Info.dob_result === 'false' || c06Info.dob_result === false"
                    icon="XIcon"
                    size="14"
                    class="text-danger ml-1"
                />
              </span>
              <button
                class="btn btn-primary"
                @click="viewC06History()"
              >
                Lịch sử kiểm tra c06
              </button>
            </div>
<!--            <span class="d-flex align-items-center">-->
<!--              <strong class="mr-1">Trạng thái:</strong>-->
<!--              <feather-icon -->
<!--                v-if="c06Info.rs === true" -->
<!--                icon="CheckIcon" -->
<!--                size="16" -->
<!--                class="text-success"-->
<!--              />-->
<!--              <feather-icon -->
<!--                v-else-if="c06Info.rs === false" -->
<!--                icon="XIcon" -->
<!--                size="16" -->
<!--                class="text-danger"-->
<!--              />-->
<!--              <span v-else class="text-muted">N/A</span>-->
<!--            </span>-->
          </div>
          <div v-else-if="c06Loading" class="c06-info mt-2" style="font-size: 14px; font-weight: normal;">
            <div class="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
            <span>Đang tải thông tin...</span>
          </div>
        </div>
      </template>
      <div v-if="imageList && imageList.length > 0" class="row">
        <div
            v-for="(image, index) in imageList"
            :key="index"
            class="col-md-6 col-lg-4 mb-4"
        >
          <div class="card image-card" @click="openFullImage(image.b64, index)">
            <div class="card-body p-2">
              <img
                  :src="'data:image/jpeg;base64,' + image.b64"
                  class="card-img-top"
                  :alt="'Ảnh ' + (index + 1)"
                  style="max-height: 200px; object-fit: contain; cursor: pointer;"
              />
              <div class="card-footer text-center p-2">
                <small class="text-muted">Ảnh {{ index + 1 }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="imageLoading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Đang tải ảnh...</p>
      </div>
      <div v-else class="text-center p-4">
        <p class="text-muted">Không tìm thấy ảnh</p>
      </div>
    </b-modal>

    <!-- Full Image Modal -->
    <b-modal
        v-model="showFullImageModal"
        :title="'Ảnh chi tiết ' + (currentImageIndex + 1) + ' - Zoom: ' + Math.round(imageZoomScale * 100) + '%'"
        size="xl"
        hide-footer
        @hidden="closeFullImageModal"
    >
      <div v-if="currentFullImage" class="text-center">
        <div class="image-container" style="overflow: auto; max-height: 70vh; border: 1px solid #ddd; padding: 10px;">
          <img
              :src="'data:image/jpeg;base64,' + currentFullImage"
              :style="{
                transform: 'scale(' + imageZoomScale + ')',
                transformOrigin: 'center',
                transition: 'transform 0.2s ease',
                maxWidth: imageZoomScale <= 1 ? '100%' : 'none',
                height: 'auto'
              }"
              alt="Ảnh chi tiết"
          />
        </div>

        <!-- Zoom Controls -->
        <div class="mt-3 d-flex justify-content-center align-items-center flex-wrap">
          <div class="zoom-controls mr-3">
            <b-button
                variant="outline-secondary"
                size="sm"
                class="mr-1"
                @click="zoomOut"
                :disabled="imageZoomScale <= 0.25"
                v-b-tooltip.hover
                title="Thu nhỏ"
            >
              <feather-icon icon="ZoomOutIcon" size="16"/>
            </b-button>
            <b-button
                variant="outline-secondary"
                size="sm"
                class="mr-1"
                @click="resetZoom"
                v-b-tooltip.hover
                title="Kích thước gốc"
            >
              <feather-icon icon="MaximizeIcon" size="16"/>
            </b-button>
            <b-button
                variant="outline-secondary"
                size="sm"
                @click="zoomIn"
                :disabled="imageZoomScale >= 3"
                v-b-tooltip.hover
                title="Phóng to"
            >
              <feather-icon icon="ZoomInIcon" size="16"/>
            </b-button>
          </div>

          <!-- Image Navigation -->
          <div v-if="imageList && imageList.length > 1" class="image-nav-controls">
            <b-button
                variant="outline-primary"
                size="sm"
                class="mr-2"
                :disabled="currentImageIndex === 0"
                @click="previousImage"
            >
              <feather-icon icon="ChevronLeftIcon" size="16"/> Trước
            </b-button>
            <span class="mx-3">{{ currentImageIndex + 1 }} / {{ imageList.length }}</span>
            <b-button
                variant="outline-primary"
                size="sm"
                class="ml-2"
                :disabled="currentImageIndex === imageList.length - 1"
                @click="nextImage"
            >
              Sau <feather-icon icon="ChevronRightIcon" size="16"/>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="showC06HisModal"
        title="Lịch sử kiểm tra c06"
        size="xl"
        hide-footer
        @hidden="showC06HisModal=false"
    >
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="thead-primary">
            <tr>
              <th style="min-width: 60px;">STT</th>
              <th style="min-width: 80px;">ID</th>
              <th style="min-width: 150px;">Số CCCD</th>
              <th style="min-width: 120px;">Ngày sinh</th>
              <th style="min-width: 180px;">Họ tên đầy đủ</th>
              <th style="min-width: 100px;">KQ CCCD</th>
              <th style="min-width: 100px;">KQ Ngày sinh</th>
              <th style="min-width: 100px;">KQ Tên</th>
              <th style="min-width: 150px;">Thời gian kiểm tra</th>
            </tr>
          </thead>
          <tbody v-if="c06Info && c06Info.detail">
            <tr v-for="(item, index) in c06Info.detail" :key="item.id">
              <td>{{ index + 1 }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.idnumber || 'N/A' }}</td>
              <td>{{ formatDob(item.dob) || 'N/A' }}</td>
              <td>{{ item.name || 'N/A' }}</td>
              <td class="text-center">
                <feather-icon
                    v-if="item.idnumber_result === 'true'"
                    icon="CheckIcon"
                    size="18"
                    class="text-success"
                />
                <feather-icon
                    v-else-if="item.idnumber_result === 'false'"
                    icon="XIcon"
                    size="18"
                    class="text-danger"
                />
                <span v-else class="text-muted">N/A</span>
              </td>
              <td class="text-center">
                <feather-icon
                    v-if="item.dob_result === 'true'"
                    icon="CheckIcon"
                    size="18"
                    class="text-success"
                />
                <feather-icon
                    v-else-if="item.dob_result === 'false'"
                    icon="XIcon"
                    size="18"
                    class="text-danger"
                />
                <span v-else class="text-muted">N/A</span>
              </td>
              <td class="text-center">
                <feather-icon
                    v-if="item.name_result === 'true'"
                    icon="CheckIcon"
                    size="18"
                    class="text-success"
                />
                <feather-icon
                    v-else-if="item.name_result === 'false'"
                    icon="XIcon"
                    size="18"
                    class="text-danger"
                />
                <span v-else class="text-muted">N/A</span>
              </td>
              <td>{{ formatDateTime(item.log_date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenuInfo from "./DropMenuInfo.vue";
import useJwt from "@/auth/jwt/useJwt";
import axios from "axios";
import {$ctx} from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment/moment";

export default {
  name: "DkttHistoryInfo",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenuInfo,
  },
  data() {
    return {
      rootClass: "search-crs-info",
      historyDataTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "action", label: "Thao tác"},
          {key: "ID", label: "ID"},
          {key: "PhoneNumber", label: "Số thuê bao"},
          {key: "Name", label: "Tên thuê bao"},
          {key: "BIRTHDAY", label: "Ngày sinh"},
          {key: "ADDRESS", label: "Địa chỉ"},
          {key: "GENDER", label: "Giới tính"},
          {key: "PASSPORT", label: "Số hộ chiếu"},
          {key: "IDNUMBERTYPE", label: "Loại giấy tờ"},
          {key: "IDNUMBER", label: "Số giấy tờ"},
          {key: "PLACEOFISSUE", label: "Nơi cấp"},
          {key: "PLACEDATE", label: "Ngày cấp"},
          {key: "COMPANY", label: "Công ty"},
          {key: "JOB", label: "Công việc"},
          {key: "EMAIL", label: "Email"},
          {key: "NATIONALITYID", label: "Quốc gia"},
          {key: "NOTE", label: "Ghi chú"},
          {key: "REGISTERMETHODID", label: "Hệ thống thực hiện"},
          {key: "MODIFYDATE", label: "Thời gian kích hoạt"},
          {key: "REGISTERDATE", label: "Ngày đăng kí"},
          {key: "AGENTID", label: "User thực hiện"},
          // {key: "AGENTNAME", label: "Tên User thực hiện"},
          // {key: "AGENTIDFIRST", label: "User thuộc kênh"},
          // {key: "REGION", label: "Miền"},
          // {key: "CUSTOMERTYPE", label: "Loại tập TB"},
        ]
      },
      CdrDetail: [],
      regex087: /87\d{7}$/,
      historyResult: "",
      showErrSearch: true,
      NumberTypeName: {45: "CCCD", 3: "Hộ chiếu", 1: "CMT"},
      showVideoModal: false,
      videoUrl: "",
      videoLoading: false,
      currentVideoId: "",
      showImageModal: false,
      imageList: [],
      imageLoading: false,
      currentImageInfo: "",
      showFullImageModal: false,
      currentFullImage: "",
      currentImageIndex: 0,
      imageZoomScale: 1,
      c06Info: null,
      c06Loading: false,
      // C06 History Modal
      showC06HisModal: false,
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    if (this.searchPhone.length > 0) {
      this.getDkttHistory();
    }
  },
  computed: {},
  methods: {
    formatPhoneNum() {
      if (this.searchPhone.startsWith("84")) {
        this.searchPhone = this.searchPhone.substring(2);
        this.searchPhone = "0" + this.searchPhone;
      }
    },
    getDkttHistory() {
      this.showLoading("block")
      useJwt.get('get-dktt-history/' + this.searchPhone).then((response) => {
        this.showLoading("none")
        this.historyResult = response.data.result;
        this.showErrSearch = false
        if (this.historyResult.length > 0) {
          this.historyResult.forEach((e) => {
            e.NAME = (e.FIRSTNAME ? e.FIRSTNAME : "") + " " + (e.MIDDLENAME ? e.MIDDLENAME : "") + " " + (e.LASTNAME ? e.LASTNAME : "");
            e.BIRTHDAY = moment(e.BIRTHDAY).format("DD/MM/YYYY");
            e.PLACEDATE = moment(e.PLACEDATE).format("DD/MM/YYYY HH:mm:ss");
            e.REGISTERDATE = moment(e.REGISTERDATE).format("DD/MM/YYYY HH:mm:ss");
            e.MODIFYDATE = moment(e.MODIFYDATE).format("DD/MM/YYYY HH:mm:ss");
            if (e.GENDER === "female") {
              e.GENDER = "Nữ"
            } else {
              e.GENDER = "Nam"
            }
            e.IDNUMBERTYPE = this.NumberTypeName[e.IDNUMBERTYPE];
            if (e.NATIONALITYID === 232) {
              e.NATIONALITYID = "Việt Nam"
            } else {
              e.NATIONALITYID = "Khác"
            }
          })
        }
        console.log("msisdn", this.historyResult);
      }).catch((error) => {
        this.showLoading("none")
        this.historyResult = ""
        this.showErrSearch = true
        console.log(error);
      });
    },

    viewVideo(idNumber, msisdn,time) {
      if (!idNumber || !msisdn || !time) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thiếu thông tin để tải video",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      console.log(moment(time,"DD/MM/YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm:ss") )
      this.currentVideoId = idNumber;
      this.showVideoModal = true;
      this.videoLoading = true;
      this.videoUrl = "";
      const formatTime=moment(time,"DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

      // Gọi API video với apikey từ localStorage và domain từ config
      axios.get(`${$ctx.API_URL}video/${idNumber}/${msisdn}/${formatTime}`, {
        headers: {
          'apikey': localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.videoLoading = false;
        if (response.data && response.data.code === 200 && response.data.result) {
          // API trả về result là string URL trực tiếp
          this.videoUrl = response.data.result;
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data?.message || "Không tìm thấy video",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        }
      }).catch(error => {
        this.videoLoading = false;
        console.error("Video API error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || "Không thể tải video",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      });
    },

    viewImage(idNumber, msisdn, modifyDate, rowIndex) {
      if (!idNumber || !msisdn || !modifyDate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thiếu thông tin để tải ảnh",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }

      // Format modifyDate từ "DD/MM/YYYY HH:mm:ss" thành "YYYY-MM-DD"
      let formattedDate = modifyDate;
      try {
        // Nếu modifyDate có format DD/MM/YYYY HH:mm:ss
        if (modifyDate.includes('/')) {
          const datePart = modifyDate.split(' ')[0]; // Lấy phần date
          const [day, month, year] = datePart.split('/');
          formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      } catch (e) {
        console.warn("Error formatting date:", e);
      }

      this.currentImageInfo = `${idNumber} - ${formattedDate}`;
      this.showImageModal = true;
      this.imageLoading = true;
      this.imageList = [];
      this.c06Info = null;
      this.c06Loading = true;

      // Gọi API image với apikey từ localStorage và domain từ config, thêm rowIndex (1, 2, 3...)
      axios.get(`${$ctx.API_URL}image/${idNumber}/${msisdn}/${formattedDate}/${rowIndex}`, {
        headers: {
          'apikey': localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.imageLoading = false;
        if (response.data && response.data.code === 200 && response.data.result) {
          this.imageList = response.data.result;
          if (this.imageList.length === 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Không tìm thấy ảnh",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data?.message || "Không tìm thấy ảnh",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        }
      }).catch(error => {
        this.imageLoading = false;
        console.error("Image API error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || "Không thể tải ảnh",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      });

      // Gọi API C06 để lấy thông tin chi tiết
      axios.get(`${$ctx.API_URL}c06/${idNumber}/${msisdn}/${formattedDate}/${rowIndex}`, {
        headers: {
          'apikey': localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.c06Loading = false;
        if (response.data && response.data.code === 200 && response.data.result) {
          this.c06Info = response.data.result;
        } else {
          console.warn("C06 API warning:", response.data?.message || "Không lấy được thông tin C06");
          this.c06Info = null;
        }
      }).catch(error => {
        this.c06Loading = false;
        console.error("C06 API error:", error);
        this.c06Info = null;
      });
    },

    openFullImage(base64, index) {
      this.currentFullImage = base64;
      this.currentImageIndex = index;
      this.imageZoomScale = 1; // Reset zoom when opening new image
      this.showFullImageModal = true;
    },

    closeImageModal() {
      this.showImageModal = false;
      this.imageList = [];
      this.currentImageInfo = "";
      this.c06Info = null;
      this.c06Loading = false;
    },

    closeFullImageModal() {
      this.showFullImageModal = false;
      this.currentFullImage = "";
      this.currentImageIndex = 0;
      this.imageZoomScale = 1; // Reset zoom when closing
    },

    previousImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.currentFullImage = this.imageList[this.currentImageIndex].b64;
        this.imageZoomScale = 1; // Reset zoom when changing image
      }
    },

    nextImage() {
      if (this.currentImageIndex < this.imageList.length - 1) {
        this.currentImageIndex++;
        this.currentFullImage = this.imageList[this.currentImageIndex].b64;
        this.imageZoomScale = 1; // Reset zoom when changing image
      }
    },

    // Zoom methods
    zoomIn() {
      if (this.imageZoomScale < 3) {
        this.imageZoomScale += 0.25;
      }
    },

    zoomOut() {
      if (this.imageZoomScale > 0.25) {
        this.imageZoomScale -= 0.25;
      }
    },

    resetZoom() {
      this.imageZoomScale = 1;
    },

    formatDob(dobString) {
      if (!dobString || dobString.length !== 8) {
        return dobString;
      }
      // Format từ "19760617" thành "17/06/1976"
      const year = dobString.substring(0, 4);
      const month = dobString.substring(4, 6);
      const day = dobString.substring(6, 8);
      return `${day}/${month}/${year}`;
    },

    closeVideoModal() {
      this.showVideoModal = false;
      this.videoUrl = "";
      this.currentVideoId = "";
      // Stop video if playing
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
    },

    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },

    viewC06History() {
      if (!this.c06Info || !this.c06Info.detail || this.c06Info.detail.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Không có dữ liệu lịch sử kiểm tra c06",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }

      this.showC06HisModal = true;
    },

    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      try {
        return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
      } catch (e) {
        return dateString;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.search-crs-info {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 16px;
    margin-right: 1rem;
    width: 100px;
  }

  &__phone-number-input {
    width: 200px;
    font-size: 16px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    .clickableButton {
      cursor: pointer;
      color: #384DC0;
      text-decoration: underline;
    }

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      padding: 0 0.5rem 0 0.5rem;
      min-width: 7rem;
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs-info {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}

// Custom styles for C06 modals
.table-responsive {
  max-height: 400px;
  overflow-y: auto;
}

.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  border-bottom: 2px solid rgba(255,255,255,0.1);
}

pre {
  font-family: 'Courier New', monospace;
  line-height: 1.4;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>
